module.exports = __webpack_public_path__ + "img/nlic_main2.bd41f161.jpg";